import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components/macro';
import { useSelector } from 'src/client/redux';
import { logoUrl } from 'src/client/helpers/urls/logoUrl';
import { TABLET_LANDSCAPE, TABLET_PORTRAIT } from 'src/client/constants/mediaQueries';

export const SiteLogo = () => {
  const site = useSelector((state) => state.site);
  const { cdnUrl } = useSelector((state) => state.app);

  return (
    <LogoLink to="/">
      <LogoImage src={logoUrl(cdnUrl, site)} alt={site.name} />
    </LogoLink>
  );
};

const LogoLink = styled(NavLink)`
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 10px;
`;

const LogoImage = styled.img`
  max-width: 110px;
  max-height: 45px;
  pointer-events: none;
  user-select: none;

  @media ${TABLET_PORTRAIT} {
    max-height: 50px;
    max-width: 170px;
  }

  @media ${TABLET_LANDSCAPE} {
    max-width: 205px;
  }
`;
